export default "__VITE_ASSET__9a18c884__"